import React, { PropsWithChildren } from 'react';

export const Body = ({ children }: Props) => {
    return (
        <>
            {children}
        </>
    );
};

type Props = PropsWithChildren<Record<never, never>>;